import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { updateDesHistory } from "../../designationHistory/designationHistoryApis";
import BtnEditSvg from "../Button/btnEditSvg";

const DesignationEditSinglePopup = ({ data, setLoading }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [StartDate, setdesignationStartDate] = useState(
        dayjs(data?.startDate).format("YYYY-MM-DD")
    );

    // We will keep EndDate null initially.
    const [EndDate, setdesignationEndDate] = useState(null);

    // Handle logic when data is updated or initially set.
    useEffect(() => {
        if (data?.endDate) {
            const validEndDate = dayjs(data.endDate, "YYYY-MM-DD", true);
            if (validEndDate.isValid()) {
                setdesignationEndDate(validEndDate); // If EndDate exists in data, set it
            } else {
                setdesignationEndDate(null); // If EndDate is invalid, keep it null
            }
        } else {
            setdesignationEndDate(null); // If no EndDate, set it as null
        }
    }, [data?.endDate]);

    const [loader, setLoader] = useState(false);
    const [designationComment, setdesignationComment] = useState("");

    const user_id = useParams("id");
    const dispatch = useDispatch();
    const designations = useSelector((state) => state.designations.list);
    const [designationId, setDesignationId] = useState(
        data?.designation?.designationId
    );

    const [initialValues, setInitialValues] = useState({
        designationId: data?.designationId || "",
        StartDate: dayjs(data?.startDate),
        EndDate: EndDate || "", // Default EndDate to last day of current month
        designationComment: data?.comment,
    });

    const onFinish = async (values) => {
		setLoading(true);
		const id = data.id || "";
		setLoader(true);
	
		// Ensure that EndDate is set to null if no valid date is selected
		const infodata = {
			...values,
			designationId: designationId,
			designationComment: designationComment || "",
			StartDate: StartDate,
			EndDate: EndDate ? EndDate : null,  // Set EndDate to null if not valid
		};
	
		console.log("Data to be updated:", infodata);  // Check the infodata
	
		const resp = await updateDesHistory(id, infodata);
	
		if (resp.message === "success") {
			setLoader(false);
			dispatch(loadSingleStaff(user_id.id));
			setInitialValues({});
			setDesignationId("");
			setdesignationComment("");
			setdesignationStartDate();
			setdesignationEndDate(null);  // Reset EndDate on success
	
			setIsModalOpen(false);
			setLoading(false);
			// window.location.reload();
		} else {
			setLoading(false);
			setLoader(false);
		}
	};
	
	console.log("Start Date:", StartDate);
	console.log("End Date:", EndDate);
	console.log("Designation ID:", designationId);
	console.log("Designation Comment:", designationComment);
		

    const onFinishFailed = (errorInfo) => {
        toast.warning("Failed at adding designation");
        setLoader(false);
        setLoading(false);
    };

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setDesignationId("");
        setdesignationComment("");
        setdesignationStartDate();
        setdesignationEndDate(null); // Reset EndDate on close
        setIsModalOpen(false);
        setLoader(false);
        setLoading(false);
    };
    const handleCancel = () => {
        setDesignationId("");
        setdesignationComment("");
        setdesignationStartDate();
        setdesignationEndDate(null); // Reset EndDate on cancel
        setIsModalOpen(false);
        setLoader(false);
        setLoading(false);
    };

    return (
        <>
            <button onClick={showModal} className="mr-2">
                <BtnEditSvg size={20} />
            </button>
            <Modal
                title={`Edit Designation`}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <Form
                    style={{ marginBottom: "100px" }}
                    eventKey="design-form"
                    initialValues={initialValues}
                    name="basic"
                    labelCol={{
                        span: 6,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <div>
                        <Form.Item
                            style={{ marginBottom: "10px" }}
                            label="Designation"
                            name="designationId"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your Designation!",
                                },
                            ]}
                        >
                            <Select
                                placeholder="Select Designation"
                                onChange={(value) => setDesignationId(value)}
                            >
                                {designations?.map((item) => (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.name || ""}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            style={{ marginBottom: "10px" }}
                            label="Start Date"
                            name="StartDate"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your start date!",
                                },
                            ]}
                        >
                            <DatePicker
                                name="StartDate"
                                format="YYYY-MM-DD"
                                value={StartDate ? dayjs(StartDate, "YYYY-MM-DD") : null}
                                onChange={(date) => setdesignationStartDate(date ? date.format("YYYY-MM-DD") : null)}
                            />
                        </Form.Item>

                        <Form.Item
                            style={{ marginBottom: "10px" }}
                            label="End Date"
                            name="EndDate"
                        >
                            <DatePicker
                                value={EndDate ? dayjs(EndDate) : null} // Display the selected EndDate if it's not null
                                format="YYYY-MM-DD"
                                placeholder="Select End Date" // Placeholder when EndDate is null
                                onChange={(date) => {
                                    if (date) {
                                        setdesignationEndDate(date); // Update EndDate if selected
                                    } else {
                                        setdesignationEndDate(dayjs().endOf("month")); // Default to the last day of current month if no date selected
                                    }
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            style={{ marginBottom: "10px" }}
                            label="Comment"
                            name="designationComment"
                        >
                            <Input name="designationComment" />
                        </Form.Item>

                        <Form.Item
                            style={{ marginBottom: "20px" }}
                            wrapperCol={{
                                offset: 6,
                                span: 12,
                            }}
                        >
                            <Button
                                onClick={() => setLoader(true)}
                                type="primary"
                                size="small"
                                htmlType="submit"
                                block
                                loading={loader}
                            >
                                Update Now
                            </Button>
                        </Form.Item>
                    </div>
                </Form>
            </Modal>
        </>
    );
};
export default DesignationEditSinglePopup;
